import css from './index.module.scss';
import { Typography } from '@components/base';
import { useFormContext } from 'react-hook-form';
import QuotePackageWrapper from '../quote-package-wrapper';

const QuoteFOBCFRPrice = (props: any) => {
  const {
    primaryUnitWatch,
    fobPrice,
    fobPriceCurrency,
    cfrPrice,
    cfrPriceCurrency,
    selectedCurrency,
    fobPriceManualOverride,
    cfrPriceManualOverride,
    cifPriceManualOverride,
    finalExWorksPrice,
    basePrice,
    cifPriceWeightUnitWatch,
    fobPriceWeightUnitWatch
  } = props;

  const { setValue, control } = useFormContext();

  return (
    <div className={css.rowWrapper}>
      <QuotePackageWrapper
        label={
          <span>
            FOB Price
            {fobPriceWeightUnitWatch && (
              <Typography variant="label"> ( Per {fobPriceWeightUnitWatch?.label} )</Typography>
            )}
          </span>
        }
        unitPlaceholder="Currency"
        inputPlaceholder="FOB Price"
        input={fobPrice}
        unit={fobPriceCurrency}
        control={control}
        unitOptions={selectedCurrency}
        currency
        inputOnChange={() => {
          setValue(cfrPriceManualOverride, false, { shouldDirty: false });
          setValue(cifPriceManualOverride, false, { shouldDirty: false });
          setValue(fobPriceManualOverride, true, {
            shouldDirty: true
          });
          setValue(finalExWorksPrice, 0);
          setValue(basePrice, 0);
        }}
      />
      <QuotePackageWrapper
        label={
          <span>
            CFR Price
            {cifPriceWeightUnitWatch && (
              <Typography variant="label"> ( Per {cifPriceWeightUnitWatch?.label} )</Typography>
            )}
          </span>
        }
        unitPlaceholder="Currency"
        inputPlaceholder="CFR Price"
        input={cfrPrice}
        unit={cfrPriceCurrency}
        control={control}
        unitOptions={selectedCurrency}
        currency
        inputOnChange={() => {
          setValue(cifPriceManualOverride, false, { shouldDirty: false });
          setValue(cfrPriceManualOverride, true, { shouldDirty: true });
          setValue(finalExWorksPrice, 0);
          setValue(basePrice, 0);
          setValue(fobPrice, 0);
        }}
      />
    </div>
  );
};

export default QuoteFOBCFRPrice;
